// Return-to-dashboard nav. When a click on the dashboard navigates the user away we remember
// the dashboard's scroll position and the exact destination, so the screen they land on can
// offer a "‹ Back to dashboard" button that returns them EXACTLY where they were. The button
// lives ONLY on the screen reached directly from the dashboard — any onward navigation drops
// the return (noteRouteChange, wired to the router), so all other navigation is untouched.
import { signal, navigate } from './t4.js';

export const dashReturn = signal(null);        // { companyId, scrollY, dest } | null
export const pendingDashScroll = signal(null); // scrollY to restore once the dashboard re-renders

// Navigate away from the dashboard, remembering where we were.
export function dashGo(companyId, dest){
  dashReturn.value = { companyId: String(companyId), scrollY: window.scrollY || 0, dest };
  navigate(dest);
}

// True on the screen reached directly from the dashboard (for this company).
export function fromDashboard(companyId){
  const r = dashReturn.value;
  return !!(r && r.companyId === String(companyId));
}

// Go back to the dashboard and restore the remembered scroll (consumed by the dashboard on load).
export function backToDashboard(companyId){
  const r = dashReturn.value;
  pendingDashScroll.value = r ? r.scrollY : 0;
  dashReturn.value = null;
  navigate('/co/' + companyId + '/dashboard');
}

// Router hook: onward navigation to anything other than the remembered destination drops the
// return, so the button never leaks onto a screen the user didn't reach from the dashboard.
export function noteRouteChange(path){
  const r = dashReturn.value;
  if(r && path !== r.dest) dashReturn.value = null;
}

// The dashboard calls this on load to restore scroll after a back-navigation (null otherwise).
export function takePendingDashScroll(){
  const y = pendingDashScroll.value;
  pendingDashScroll.value = null;
  return y;
}
